import { parse, printParseErrorCode, type ParseError } from "jsonc-parser";

export function parseJsonc(source: string, sourceName: string): unknown {
  const errors: ParseError[] = [];
  const value = parse(source, errors, { allowTrailingComma: false });
  if (errors.length > 0) {
    const first = errors[0];
    const before = source.slice(0, first.offset);
    const line = before.split("\n").length;
    const lastBreak = before.lastIndexOf("\n");
    const column = first.offset - (lastBreak < 0 ? -1 : lastBreak);
    throw new Error(
      `Invalid JSONC in ${sourceName} at ${line}:${column}: ${printParseErrorCode(first.error)}`,
    );
  }
  return value;
}
